import {
  scCoreModule
} from '../core/core.module';

import {
  AdminModalService
} from './admin-modal.service';

export const scAdminModule = 'sc-admin';

angular.module(scAdminModule, [scCoreModule])
  .service('AdminModalService', AdminModalService);



// WEBPACK FOOTER //
// ./src/admin/admin.module.js